import React, { useState, useEffect } from "react";
import {
  Modal,
  Form,
  Button,
  Row,
  Col,
  Select,
  Input,
  Notification,
} from "antd";
import { isEmpty, get } from "lodash";
import API from "../../utils/Api";
import Cookies from "js-cookie";


const { Option } = Select;

const AddBroadCast = (properties) => {
  const myApi = new API({});
  myApi.createEntity({ name: "broadCast" });
  const { openModal, handleCloseModal, users, editData } = properties;
  const [loading, setLoading] = useState(false);
  const [selectedUser, setSelectedUser] = useState([]);
  const [appKey] = useState(Cookies.get("appKey"));
  const [form] = Form.useForm();

  const onSelectUser = (value) => {
    form.setFieldsValue({
      filterUserBy: value,
      users: value,
    });
    setSelectedUser(value);
  };
  useEffect(() => {
    const userList = get(editData, "user_list", []);
    const filterData = userList.map((data) => data.phone_number);
    form.setFieldsValue({
      broadCast: editData.name,
      users: filterData,
      filterUserBy: filterData,
    });
    setSelectedUser(filterData);
  }, [editData]);

  const onFinish = (values) => {
    setLoading(true);
    const filterData = users.filter((data) =>
      selectedUser.includes(data.phone_number)
    );
    const sectionText = values?.broadCast.trim().split(/ +/).join(" ");
    if (isEmpty(sectionText)) {
      setLoading(false);
      return Notification.error({ message: "Invalid BroadCast Name!" });
    }
    if (isEmpty(filterData)) {
      setLoading(false);
      return Notification.error({ message: "Please Select a Users!" });
    }
    const params = {
      broadCastName: sectionText,
      users: filterData,
      camp_app_key: appKey,
      isCreate: true,
    };
    if (!isEmpty(editData)) {
      params.isCreate = false;
    }
    myApi.endpoints.broadCast
      .send(params, {}, "createOrUpdate")
      .then((res) => {
        const getData = get(res, "data");
        if (!getData.success) {
          Notification.error({ message: getData.error });
          setLoading(false);
        } else {
          Notification.success({
            message: isEmpty(editData)
              ? "Created Successfully"
              : "Updated Successfully",
          });
          handleCloseModal();
          setLoading(false);
        }
      })
      .catch((error) => {
        setLoading(false);
        Notification.error({ message: error.message || "Failed to create" });
      });
  };

  return (
    <>
      <Modal
        title={isEmpty(editData) ? "Add New BroadCast" : "Update BroadCast"}
        footer={null}
        visible={openModal}
        onCancel={handleCloseModal}
      >
        <Form form={form} onFinish={onFinish} autoComplete="off">
          <Form.Item
            label="BroadCast Name"
            name="broadCast"
            rules={[
              {
                required: true,
                message: "Please input your BroadCast Name!",
              },
            ]}
          >
            <Input disabled={!isEmpty(editData)} size="middle" />
          </Form.Item>
          <Form.Item
            label="Select Users"
            name="users"
            rules={[
              {
                required: true,
                message: "Please Select a Users!",
              },
            ]}
          >
            <Col span={24}>
              <Select
                onChange={onSelectUser}
                mode="multiple"
                size="large"
                value={selectedUser}
                placeholder="Select users"
                className="filter-user"
                filterOption={(input, option) =>
                  option.children
                    .toLowerCase()
                    .includes(input.toLowerCase()) === true
                }
              >
                {users &&
                  users.map((item) => (
                    <Option key={item.user_id} value={item.phone_number}>
                      {item.user_name}
                    </Option>
                  ))}
              </Select>
            </Col>
          </Form.Item>
          <Row>
            <Col span={24}>
              <Form.Item>
                <div className="footer-btn">
                  <Button onClick={handleCloseModal}>Cancel</Button>
                  <Button
                    loading={loading}
                    className="ml-2"
                    type="primary"
                    htmlType="submit"
                  >
                    {isEmpty(editData) ? "Save" : "Update"}
                  </Button>
                </div>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>
    </>
  );
};

export default AddBroadCast;
